import React, {Component} from 'react';
import { withRouter } from "react-router-dom";





class InstallMobileApp extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Install The Mobile App </h2>

                <br/>
               

                <h6> Step 1: The App Stores</h6>
                
                <p className='text-primary'>Got to the Apple Store or the Google Play stores and download the app.  </p>

                         * Download the BOUNTE mobile app in the <a href='https://apps.apple.com/us/app/bounte/id1262003089?ls=1'>iTunes App Store</a> 
                         <div className="text-center">
                            <img className='text-center' style={{width:"40%", height:"40%"}} src='./images/appstore.png' alt=''/> 
                        </div>

                        <hr/>
                         <br/><br/>
                         or <a href= 'https://play.google.com/store/apps/details?id=com.bounte&hl=en_US'>Google Play </a> stores.  
                         <div className="text-center">
                            <img className='text-center' style={{width:"40%", height:"40%"}} src='./images/googleplay.png' alt=''/> 
                        </div>


                <p className='text-danger'> When installing the app, click YES to use of Geolocation, video/Mic, and Camera.  These are important and utilized when adding lost and found items! </p>

                <br/><br/><br/>
                


                 <br/> 
              


                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(InstallMobileApp);
